import { render, staticRenderFns } from "./OldRegApplicationTab.vue?vue&type=template&id=8b2c33a2&scoped=true&"
import script from "./OldRegApplicationTab.vue?vue&type=script&lang=js&"
export * from "./OldRegApplicationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c33a2",
  null
  
)

export default component.exports